import { useEffect, useState } from "react";
import { AiFillInstagram } from "react-icons/ai";
import { BsPinterest } from "react-icons/bs";
import { FaLinkedinIn, FaTwitter, FaYoutube } from "react-icons/fa";
import { GrFacebookOption } from "react-icons/gr";
import styles from "./social_links.module.scss";
import Cookies from "js-cookie";

export const SocialLinks = () => {
  const [defaultCountryCode, setDefaultCountryCode] = useState();
  useEffect(() => {
    setTimeout(() => {
      if (typeof Cookies == "object") {
        if (Cookies.get("default_country")) {
          setDefaultCountryCode(Cookies.get("default_country"));
        }
      }
    }, 1500);
  }, [defaultCountryCode]);

  const facebbokSocila = {
    // in: "https://www.facebook.com/UniSearchBangladesh",
    my: "https://www.facebook.com/UniSearchMalaysia",
  };

  const instratSocila = {
    in: "https://www.instagram.com/unisearchindia",
    my: "https://www.instagram.com/myunisearch",
  };
  return (
    <ul className={styles.social_links}>
      <li>
        <a
          rel="nofollow"
          target="_blank"
          href="https://twitter.com/myunisearch"
        >
          <FaTwitter />
        </a>
      </li>
      <li>
        <a
          rel="nofollow"
          target="_blank"
          href="https://www.linkedin.com/company/my-unisearch"
        >
          <FaLinkedinIn />
        </a>
      </li>
      <li>
        <a
          rel="nofollow"
          target="_blank"
          href={
            facebbokSocila[defaultCountryCode] ??
            `https://www.facebook.com/UniSearchBangladesh`
          }
        >
          <GrFacebookOption />
        </a>
      </li>
      <li>
        <a
          rel="nofollow"
          target="_blank"
          href="https://www.youtube.com/channel/UCCHQrxOr5olDBxypJUE7qZw"
        >
          <FaYoutube />
        </a>
      </li>
      <li>
        <a
          rel="nofollow"
          target="_blank"
          href={
            instratSocila[defaultCountryCode] ??
            `https://www.instagram.com/unisearchindia`
          }
        >
          <AiFillInstagram style={{ fontSize: "18px" }} />
        </a>
      </li>
      <li>
        <a
          rel="nofollow"
          target="_blank"
          href="https://www.pinterest.com/myunisearch"
        >
          <BsPinterest style={{ fontSize: "16px" }} />
        </a>
      </li>
    </ul>
  );
};

export default SocialLinks;
